import { PageVisibilityFunctions } from '../types';
import requestToVaryDeclaration from '../RequestToVaryForm/requestToVaryDeclaration';

export const RequestToVary: PageVisibilityFunctions = {
    requestToVaryDeclaration,
};
